import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function LastnameCannotBeEmptyErrorToast(props: Props) {
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="error"
      body={polyglot.t("toasts.lastname_cannot_be_empty_error.body")}
      id={props.id}
    />
  )
}
